import { Component, OnInit, Input, Output, EventEmitter, OnChanges  } from '@angular/core';

@Component({
  selector: 'app-starbase-dropdown',
  templateUrl: './qm-dropdown.component.html',
  styleUrls: ['./qm-dropdown.component.css']
})
export class QMDropdownComponent implements OnInit, OnChanges {
  @Output() selectItemEvent = new EventEmitter<any[]>();
  @Input() isMultiSelect: boolean;
  @Input() dataSource: any[];
  @Input() textField: string;
  @Input() valueField: string;
  @Input() displayLabel: string;
  @Input() selectedValues: any[];

  private selectedIndices: number[] = [];
  public isOpen = false;


  clickEvent(index: number) {

    if (!this.isMultiSelect) {
      this.selectedIndices = [];
      this.selectedIndices.push(index);
      this.openClose();
    } else {
      let found = false;
      for (let i = 0; i < this.selectedIndices.length; i++) {
        if (this.selectedIndices[i] === index) {
           this.selectedIndices.splice(i, 1);
           found = true;
           break;
        }
      }

      if (!found) {
        this.selectedIndices.push(index);
      }
    }

    const resultArray = [];
    for (let i = 0; i < this.selectedIndices.length; i++) {
      resultArray.push( (this.valueField ? this.dataSource[this.selectedIndices[i]][this.valueField] : this.dataSource[this.selectedIndices[i]]) );
    }

    this.selectItemEvent.emit(resultArray);
  }

  constructor() {
  }

  openClose() {
    this.isOpen = !this.isOpen;
  }

  isIndexSelected(index: number) {
      const item = this.selectedIndices.find(x => x === index);

      if (item != null) {
        return true;
      }

      return false;
  }

  getLabel() {
    let selectedItem = 0;

    if (!this.isMultiSelect && this.selectedIndices.length > 0) {
        selectedItem = (this.textField ? this.dataSource[this.selectedIndices[0]][this.textField] : this.dataSource[ this.selectedIndices[0] ]  );
    }

    const lab =  ( selectedItem === 0 ? (this.displayLabel ? (this.displayLabel + (this.selectedIndices.length > 0 ? ' (' + this.selectedIndices.length + ')' : '') ) : 'Please make a selection') :  selectedItem);
    return lab;
  }

  getItemText(item: any) {
    if (item) {
      if (!this.textField) {
        return item;
      } else {
        return item[this.textField];
      }
    }
  }

  ngOnChanges() {

  }

  ngOnInit() {
    if (this.selectedValues !== undefined && this.selectedValues !== null && this.dataSource !== undefined && this.dataSource != null) {
      if (this.selectedValues.length > 0 && this.dataSource.length > 0) {
        for (let i = 0; i < this.selectedValues.length; i++) {
          let item = -1;
          if (this.valueField) {
            item = this.dataSource.findIndex(x => x[this.valueField] === this.selectedValues[i]);
          } else {
            item = this.dataSource.findIndex(x => x === this.selectedValues[i]);
          }

          if (item > -1) {
            this.selectedIndices.push(item);
          }
        }
      }
    }
  }

}
